module.exports = __webpack_public_path__ + "static/media/PickNTrackLogo.f735647b.jpeg";